<template>

    <el-collapse v-model="activeName" accordion>

        <el-collapse-item v-for="(history, key) in historyList" :key="key" :name="key">

            <template slot="title">

                <i class="el-icon-circle-check">
                    {{history.op_node_name}}
                </i>
                &#12288;&#12288;&#12288;
                <i class="el-icon-date">
                    {{history.sys_ts}}
                </i>
                &#12288;&#12288;&#12288;
                <i class="el-icon-user-solid">
                    {{history.sys_user}}
                </i>
                &#12288;&#12288;&#12288;

                <i :class="history.attach == '' ? '' : 'el-icon-paperclip'"></i>

            </template>

            <div>{{history.remark}}</div>

            <div v-html="history.attach"></div>

        </el-collapse-item>

    </el-collapse>

</template>


<script>

    import WorkflowApi, {WorkflowApiNew} from '../../api/workflow/workflow'

    export default {

        name: 'workflow',

        props: {
            bussiness: {},
            bussinessId: {},
            useNewApi: {
                type: Boolean,
                default: false,
            }
        },

        data() {

            return {
                activeName: '',
                historyList: [],
            }

        },

        computed: {
            api() {
                return this.useNewApi === true ? WorkflowApiNew : WorkflowApi;
            }
        },

        methods: {

            getHistoryList() {
                this.api.history({bussiness: this.bussiness, bussinessId: this.bussinessId}).then(responseBody => {
                    this.historyList = responseBody;
                    this.activeName = this.historyList.length - 1;
                    this.$emit('loaded', this.historyList);
                });
            }

        },

        watch: {
            bussinessId: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal) {
                        this.getHistoryList();
                    }
                }
            }
        }

    }
</script>
